const PARTNERS = {
  aceTheGre: 'acethegre',
  amizoa: 'amizoa',
  anking: 'anking',
  arthur: 'arthur',
  basicWisdom: 'basic-wisdom',
  benWhite: 'benwhite',
  capitalAdvantage: 'capital-advantage',
  crush: 'crush',
  crushGre: 'crushgre',
  discount: 'discount',
  dotdash: 'Dotdash',
  edge: 'edg3',
  eduReviewer: 'EduReviewer',
  examStrategist: 'ExamStrategist',
  graceUsmle: 'graceusmle',
  guru99: 'guru99',
  mattRoy: 'mattRoy',
  myGre: 'mygre',
  myGuru: 'myguru',
  placementBoat: 'placementboat',
  series7ExamTutor: 'series7examtutor',
  stellar: 'stellar',
  testGuide: 'TestGuide',
  tpi: 'tpi',
  wesCarroll: 'wescarroll',
  wikiJob: 'wikijob',
  wso: 'wso',
};

const PRODUCTS = {
  amc8: 'amc-8',
  amc10: 'amc-10',
  amc12: 'amc-12',
  finraBundleEverything: 'finra-everything',
  finraBundleSieS7: 'finra-bundle-sie-s7',
  finraSeries6: 'finra-series-6',
  finraSeries63: 'finra-series-63',
  finraSeries65: 'finra-series-65',
  finraSeries66: 'finra-series-66',
  finraSeries7: 'finra-series-7',
  finraSie: 'finra-sie',
  gre: 'gre',
  gre2022: 'gre-2022',
  usmleStep1: 'usmle-step-1',
};

const DATA = {
  permissions: {
    'brandon@basicwisdom.net': PARTNERS.basicWisdom,
    'james@wescarroll.com': PARTNERS.wesCarroll,
    'mattry771@gmail.com': PARTNERS.mattRoy,
    'oriontaraban@gmail.com': PARTNERS.stellar,
    'sujata@graceusmletutoring.com': PARTNERS.graceUsmle,
    'wes@wescarroll.com': PARTNERS.wesCarroll,
  },
  partners: {
    [PARTNERS.aceTheGre]: {
      authorShare: 0,
      authorReferredShare: 0,
      affiliateShare: 0.3,
      products: [],
    },
    [PARTNERS.amizoa]: {
      authorShare: 0,
      authorReferredShare: 0,
      affiliateShare: 0.3,
      products: [],
    },
    [PARTNERS.anking]: {
      authorShare: 0,
      authorReferredShare: 0,
      affiliateShare: 0.2,
      products: [],
    },
    [PARTNERS.arthur]: {
      authorShare: 0,
      authorReferredShare: 0,
      affiliateShare: 0.4,
      products: [],
    },
    [PARTNERS.basicWisdom]: {
      authorShare: 0.4,
      authorReferredShare: 0.6,
      affiliateShare: 0,
      products: [
        PRODUCTS.finraBundleEverything,
        PRODUCTS.finraBundleSieS7,
        PRODUCTS.finraSie,
        PRODUCTS.finraSeries6,
        PRODUCTS.finraSeries7,
        PRODUCTS.finraSeries63,
        PRODUCTS.finraSeries65,
        PRODUCTS.finraSeries66,
      ],
    },
    [PARTNERS.benWhite]: {
      authorShare: 0,
      authorReferredShare: 0,
      affiliateShare: 0.25,
      products: [],
    },
    [PARTNERS.capitalAdvantage]: {
      authorShare: 0,
      authorReferredShare: 0,
      affiliateShare: 0.5,
      products: [],
    },
    [PARTNERS.crush]: {
      authorShare: 0,
      authorReferredShare: 0,
      affiliateShare: 0.3,
      products: [],
    },
    [PARTNERS.crushGre]: {
      authorShare: 0,
      authorReferredShare: 0,
      affiliateShare: 0.4,
      products: [],
    },
    [PARTNERS.discount]: {
      authorShare: 0,
      authorReferredShare: 0,
      affiliateShare: 0.25,
      products: [],
    },
    [PARTNERS.dotdash]: {
      authorShare: 0,
      authorReferredShare: 0,
      affiliateShare: 0.25,
      products: [],
    },
    [PARTNERS.edge]: {
      authorShare: 0,
      authorReferredShare: 0,
      affiliateShare: 0.3,
      products: [],
    },
    [PARTNERS.eduReviewer]: {
      authorShare: 0,
      authorReferredShare: 0,
      affiliateShare: 0.25,
      products: [],
    },
    [PARTNERS.examStrategist]: {
      authorShare: 0,
      authorReferredShare: 0,
      affiliateShare: 0.25,
      products: [],
    },
    [PARTNERS.graceUsmle]: {
      authorShare: 0.4,
      authorReferredShare: 0.6,
      affiliateShare: 0,
      products: [PRODUCTS.usmleStep1],
    },
    [PARTNERS.guru99]: {
      authorShare: 0,
      authorReferredShare: 0,
      affiliateShare: 0.4,
      products: [],
    },
    [PARTNERS.mattRoy]: {
      authorShare: 0.08,
      authorReferredShare: 0.28,
      affiliateShare: 0,
      products: [
        PRODUCTS.gre2022,
      ],
    },
    [PARTNERS.myGuru]: {
      authorShare: 0,
      authorReferredShare: 0,
      affiliateShare: 0.3,
      products: [],
    },
    [PARTNERS.myGre]: {
      authorShare: 0,
      authorReferredShare: 0,
      affiliateShare: 0.3,
      products: [],
    },
    [PARTNERS.placementBoat]: {
      authorShare: 0,
      authorReferredShare: 0,
      affiliateShare: 0.5,
      products: [],
    },
    [PARTNERS.series7ExamTutor]: {
      authorShare: 0,
      authorReferredShare: 0,
      affiliateShare: 0.5,
      products: [],
    },
    [PARTNERS.stellar]: {
      authorShare: 0.4,
      authorReferredShare: 0.6,
      affiliateShare: 0,
      products: [PRODUCTS.gre],
    },
    [PARTNERS.testGuide]: {
      authorShare: 0,
      authorReferredShare: 0,
      affiliateShare: 0.25,
      products: [],
    },
    [PARTNERS.tpi]: {
      authorShare: 0,
      authorReferredShare: 0,
      affiliateShare: 0.3,
      products: [],
    },
    [PARTNERS.wesCarroll]: {
      authorShare: 0.4,
      authorReferredShare: 0.6,
      affiliateShare: 0,
      products: [PRODUCTS.amc8, PRODUCTS.amc10, PRODUCTS.amc12],
    },
    [PARTNERS.wikiJob]: {
      authorShare: 0,
      authorReferredShare: 0,
      affiliateShare: 0.3,
      products: [],
    },
    [PARTNERS.wso]: {
      authorShare: 0,
      authorReferredShare: 0,
      affiliateShare: 0.5,
      products: [],
    },
  },
};

module.exports = DATA;
